import React from 'react';
import { Asset } from '../../../types/asset';
import { RichText } from '../../richText';
import { Document } from '@contentful/rich-text-types';
import {ImageTextProps} from '../imageText';

interface ImageTextCollectionProps {
  imageTexts: ImageTextProps[];
}

const ImageText: React.FC<{imageText: ImageTextProps, index: number}> = (({ imageText, index }) => {
    return (
        <div className={`flex-1 flex flex-col sm:border-black ${index === 0 ? 'sm:border-r' : ''}`}>
            <div className={'w-full bg-cover bg-center font-playfair text-white flex items-end pb-8 pl-6 text-4xl'} style={{ height: '34rem', backgroundImage:  `linear-gradient(rgba(180, 180, 180, 0) 60%, rgba(60, 60, 60, 0.8)), url(${imageText.image.url})` }}>
                <p>{imageText.name}</p>
            </div>
            <div className={'px-8 sm:p-16 py-12 lg:p-24'}>
                <RichText content={imageText.text} />
            </div>
        </div>
    );
});

export const ImageTextCollection: React.FC<ImageTextCollectionProps> = ({ imageTexts }) => {
    return (
      <div className={'flex flex-col sm:flex-row border-t border-b border-black'}>
          {imageTexts.map((imageText, index) => <ImageText index={index} key={index} imageText={imageText} />)}
      </div>
  );
};
